export const screenSizes = {
	mobileMax: 500,
	collapseSidebar: 760,
};
